<template>
  <v-container>
    <v-toolbar flat>
      <v-card-actions>
        <v-icon @click="$router.go(-1)" color="secondary"  style="margin-right: 10px">
          mdi-arrow-left-thick
        </v-icon>
      </v-card-actions>
        <v-toolbar-title style=""><b>Add Lesson</b></v-toolbar-title>
          <v-spacer></v-spacer>
    </v-toolbar>

    <v-form ref="form" @submit.prevent="saveLesson" class="custom_form">
      <v-card>
        <v-dialog persistent v-model="editTextDialog" width="900" height="800">
          <EditText :editedText="toBeEditedText" @changeEditedText="changeEditedText($event)"/>
        </v-dialog>
        <v-container>
          <v-row no-gutters>
            <v-col cols="2" align="right" class="mr-3">
              <v-card-text class="pr-5"> Title </v-card-text>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="lesson.lessonTitle"
                outlined
                dense 
                clearable
                @click="editTextTitle($event)"
                :rules="lessonTitleRules"
                :success="lessonTitleSuccess"
              ></v-text-field>
            </v-col>
          </v-row>
          
          <v-row no-gutters>
            <v-col cols="2" align="right" class="mr-3">
              <v-card-text class="pr-5">
                Description
              </v-card-text>
            </v-col>
            <v-col cols="6">
                <v-text-field
                  v-model="lesson.lessonDescription"
                  outlined
                  dense 
                  clearable
                  @click="editTextDescription($event)"
                  :rules="lessonDescriptionRules"
                  :success="lessonDescriptionSuccess"
                ></v-text-field>
            </v-col>
          </v-row>
        
        <v-row no-gutters>
          <v-col cols="2" align="right" class="mr-3">
            <v-card-text class="pr-5">
              Introduction
            </v-card-text>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="lesson.lessonIntroduction"
              outlined
              dense 
              clearable
              @click="editTextIntroduction($event)"
              :rules="lessonIntroductionRules"
              :success="lessonIntroductionSuccess"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col cols="2" align="right" class="mr-3">
            <v-card-text class="pr-5">
              Instructions
            </v-card-text>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="lesson.lessonInstruction"
              outlined
              dense 
              clearable
              @click="editTextInstruction($event)"
              :rules="lessonInstructionRules"
              :success="lessonInstructionSuccess"
            ></v-text-field>
          </v-col>
        </v-row>
    
        <v-data-table
          dense
          fixed-header
          :headers="headers" 
          bold
          :items="lesson.lessonStatementKeySequenceArray"
          :items-per-page="10"
          sort-by="['serialNum', 'lessonStatement', 'lessonKeySequence']"
          :search="search"
        >
          <template v-slot:top>
            <v-toolbar
              flat
            >
             <v-toolbar-title style="font-size:17px">Statement and Key Sequence</v-toolbar-title>
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>
                <v-spacer></v-spacer>
                <v-dialog
                  persistent
                  v-model="dialog"
                  max-width="700px"
                >
                    <v-dialog persistent v-model="editTextDialogStatement" width="900" height="800">
                      <EditText :editedText="toBeEditedText" @changeEditedText="changeEditedText($event)"/>
                    </v-dialog> 

                  <template v-slot:activator="{on,  attrs }">
                    <v-btn
                      color="secondary"
                      dark
                      class="mb-2"
                      v-on="on"
                      v-bind="attrs"
                    >
                      New Item
                    </v-btn>
                <!-- v-bind="attrs" -->
                 <!-- v-on="on" -->
                  </template>
            
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col
                          cols="12"
                          sm="6"
                          md="8"
                        >
                          <v-text-field
                            v-model="editedItem.lessonStatement"
                            label="Statement"
                            @click="editTextStatement($event)"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row class="ml-1">
                        Key Sequence
                        <v-col
                          cols="12"
                        >
                          <div style="width:600;height:500">
                            <span  v-for="(itm, indx) in editedItem.lessonKeySequence" :key='indx'>
                              <v-chip :key="indx" close @click:close="deleteKey(indx)">
                                {{itm}}  
                              </v-chip>
                            </span> 
                          </div>
                        </v-col> 
                      </v-row>

                      <v-row>        
                        <v-card style="width:150px" class="ml-5">
                          <ul style="text-decoration:none" v-for="(key, i) in keySequenceMaster4" :key="i">
                            <v-row>
                              <v-col cols="5" style="font-size:15px" no-gutters class="ma-0 pa-0">
                                {{key}}
                              </v-col>
                              <v-col cols="1" class="ml-0 pl-0 ma-0 pa-0"><v-icon style="font-size:15px" no-gutters @click="addKey4(i)">mdi-plus</v-icon>
                              </v-col>
                            </v-row>
                          </ul>
                        </v-card>

                        <v-card style="width:150px" class="ml-5">
                          <ul style="text-decoration:none" v-for="(key, i) in keySequenceMaster5" :key="i">
                            <v-row>
                              <v-col cols="5" style="font-size:15px" class="ma-0 pa-0">
                                {{key}}
                              </v-col>
                              <v-col cols="1" class="ml-0 pl-0 ma-0 pa-0"><v-icon style="font-size:15px" @click="addKey5(i)">mdi-plus</v-icon>
                              </v-col>
                            </v-row>
                          </ul>
                        </v-card>

                        <v-card style="width:150px" class="ml-5">
                          <ul style="text-decoration:none" v-for="(key, i) in keySequenceMaster6" :key="i">
                            <v-row>
                              <v-col cols="5" style="font-size:15px" class="ma-0 pa-0">
                                {{key}}
                              </v-col>
                              <v-col cols="1" class="ml-0 pl-0 ma-0 pa-0"><v-icon  style="font-size:15px" @click="addKey6(i)">mdi-plus</v-icon>
                              </v-col>
                            </v-row>
                          </ul>
                        </v-card>  
                      </v-row>
                    </v-container>
                  </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="close"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="save"
                >
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="headline">Are you sure you want to delete this item?</v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                    <v-btn color="blue darken-1" text @click="deleteLessonStatementKeySequenceConfirm">OK</v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar> 
      </template>

      <template v-slot:item.serialNum="{item}">
        {{lesson.lessonStatementKeySequenceArray.indexOf(item)+1}} 
      </template>

      <template v-slot:item.lessonKeySequence="{item}">
        {{itemToString(item)}} 
      </template>
        
      <template v-slot:item.edit_deleteDetails="{item}">
        <v-tooltip bottom>
          <template v-slot:activator="{on}">
            <v-icon
              class="mr-2"
              color="blue darken-3"
              v-on="on"
              @click="editLessonStatementKeySequence(item)"
            >mdi-pencil
            </v-icon>
          </template>
            <span>View Details</span>
              </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{}">
                    <v-icon
                      class="mr-2"
                      color="blue darken-3"
                      v-on:click="deleteLessonStatementKeySequence(item)"
                      >mdi-delete
                    </v-icon>    
                  </template>
                <span>Delete</span>
              </v-tooltip>
            </template>
            </v-data-table>
              <!-- <v-row no-gutters>
                <v-col cols="2" align="right" class="mr-3">
                  <v-card-text class="pr-5">
                    Maximum Wrong Count
                  </v-card-text>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="lesson.lessonMaxWrongCount"
                    outlined
                    dense 
                    clearable
                    :rules="lessonMaxWrongCountRules"
                    :success="lessonMaxWrongCountSuccess"
                  ></v-text-field>
                </v-col>
              </v-row> -->

              <v-row no-gutters>
                <v-col cols="2" align="right" cla ss="mr-3">
                  <v-card-text class="pr-5">Lesson Status</v-card-text>
                </v-col>
                <v-col cols="6">
                  <v-switch
                    v-model="lesson.lessonStatus"
                    inset
                    dense
                    class="mt-2" 
                    color="blue"
                    :label="lesson.lessonStatus ? 'Active' : 'Inactive'"
                  >
             <!-- @change="saveStatus(item._id, item.courseStatus)" -->
                  </v-switch>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col cols="2" align="right" cla ss="mr-3">
                  <v-card-text class="pr-5">Paid</v-card-text>
                </v-col>
                <v-col cols="6">
                  <v-switch
                    v-model="lesson.isPaid"
                    inset
                    dense
                    class="mt-2" 
                    color="blue"
                    :label="lesson.isPaid ? 'Paid' : 'Free'"
                  >
             <!-- @change="saveStatus(item._id, item.courseStatus)" -->
                  </v-switch>
                </v-col>
              </v-row>


              <v-row v-if="errorMessage || successMessage">
                <v-col cols="6" offset-md="2">
                  <v-alert v-if="errorMessage" type="error">
                    {{errorMessage}}
                  </v-alert>
                  <v-alert v-if="successMessage" type="success">
                    {{successMessage}}
                  </v-alert>
                </v-col>
              </v-row>
            <v-divider></v-divider>
            <v-row>
              <v-col cols="10">
                <v-card-actions style="justify-content:center;">
                <v-btn class="mx-5" text @click="$router.go(-1)">cancel</v-btn>
                <v-btn
                  class="mx-5"
                  :disabled="disabled"
                  type="submit"
                  color="secondary"
                  width="90"
                  @click="saveLesson"
                    >Submit</v-btn
                    >
                </v-card-actions>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-form>
    </v-container>
</template>

<script>
import Lesson from "../../models/Lesson";
import EditText from "../../components/admin/EditText";
//import axios from "axios";
//import url1 from '../../../config.js'
//const url=`${url1.url}/api/lesson`;
export default {
     beforeRouteEnter(to, from, next) {
        next(vm => {
            setTimeout(() => {
                if (!vm.$store.state.auth.adminUser._id)
                    vm.$router.push("/");
            }, 0);
        });
    },
    name: "AddLesson",
     components:{
        EditText
    },
    data() {
        return {
                search:'',
                disabled:false,
                dialog: false,
                dialogDelete: false,
                editedIndex:-1,
                toBeEditedText:'',
                editTextDialog:false,
                editTextDialogStatement:false,
                inputType: '',
                textField:null,
                editedItem:{lessonKeySequence:[], lessonStatement:''},
                defaultItem:{lessonKeySequence:[], lessonStatement:''},
                lesson:new Lesson(),
                successMessage:'',
                errorMessage:'',

                keySequenceMaster4:[
                  "4A","4A#", "4B", "4C", "4C#", "4D", "4D#", "4E", "4F", "4F#", "4G", "4G#"
                 ], 

                keySequenceMaster5:[
                  "5A","5A#", "5B", "5C", "5C#", "5D", "5D#", "5E", "5F", "5F#", "5G", "5G#"
                 ], 

                keySequenceMaster6:[
                  "6A","6A#", "6B", "6C", "6C#", "6D", "6D#", "6E", "6F", "6F#", "6G", "6G#"
                 ], 
                headers: [
                    {text: 'S. No.', value: 'serialNum' },
                    {text:"Statement", value:"lessonStatement"},
                    {text:"Key Sequence", value:"lessonKeySequence"},
                    {text:"Edit/Delete", value:"edit_deleteDetails"}
                ],                
                lessonTitleSuccess: false,
                lessonTitleRules: [
                  v => {
                    if (v)
                      {
                        this.lessonTitleSuccess = true;
                        return true;
                      } else {
                          this.lessonTitleSuccess = false;
                          return "Title is required";
                      }
                    },
                // v=>{
                //     if(v.length>=2)
                //     {
                //         this.firstNameSuccess = true;
                //         return true;
                //     }
                //     else{
                //        // this.firstNameSuccess=false;
                //         console.log('check first name success', this.firstNameSuccess );
                //        // return false; //return "First Name must be more than 2 characters long";
                //     }
                // },

                //    v=>{
                //     if(v.length<=30)
                //     {
                //         this.firstNameSuccess = true;
                //         return true;
                //     }
                //     else{
                //         this.firstNameSuccess=false;
                //           return "First name must be less than 30 characters long";
                //     }
               // },
                  v =>
                    (v || "").length >= 2 ||
                    "Title must be at least 2 characters long",
                  v =>
                    (v || "").length <= 30||
                    "Title must be less than 30 characters"
                ],

              lessonDescriptionSuccess:false,
              lessonDescriptionRules: [
                v => {
                  if (v) {
                    this.lessonDescriptionSuccess = true;
                      return true;
                  } else {
                      this.lessonDescriptionSuccess = false;
                      return "Description is required";
                  }
                },
                v =>
                  (v || "").length >= 2 ||
                  "Description be at least 2 characters long",
                v =>
                  (v || "").length <= 255 ||
                  "Description must be less than 255 characters"
            ],
            
            lessonIntroductionSuccess:false,
            lessonIntroductionRules: [
                     v => {
                    if (v) {
                        this.lessonIntroductionSuccess = true;
                        return true;
                    } else {
                        this.lessonIntroductionSuccess = false;
                        return "Introduction is required";
                    }
                    },
                v =>
                    (v || "").length >= 2 ||
                    "Introduction be at least 2 characters long",
                v =>
                    (v || "").length <= 255||
                    "Introduction must be less than 255 characters"
            ],
            
            lessonInstructionSuccess:false,
            lessonInstructionRules: [
                     v => {
                    if (v) {
                        this.lessonInstructionSuccess = true;
                        return true;
                    } else {
                        this.lessonInstructionSuccess = false;
                        return "Introduction is required";
                    }
                    },
                v =>
                    (v || "").length >= 2 ||
                    "Instruction be at least 2 characters long",
                v =>
                    (v || "").length <= 255 ||
                    "Instruction must be less than 255 characters"
            ],

            // lessonImageSuccess: false,
            // lessonImageRules: [        
            //     v =>
            //         (!v || v.size<1000000) ||"Lesson Image size should be less than 1MB",
            //     ],
                // v =>{
                //     if(/.+@.+\..+/.test(v))
                //     {
                //         this.emailValidationFlag=true;
                //     }
                //     else{
                //         this.emailValidationFlag=false;
                //         return   "E-mail must be valid";
                //     }
                // },
                 //  v =>   /.+@.+\..+/.test(v) || "E-mail must be valid" ///^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

              /*
            lessonAudioSuccess: false,
            lessonAudioRules: [        
                v =>
                    (!v || v.size<1000000) ||"Lesson audio size should be less than 1MB",
                ],
              */
                
                /*
                lessonStatementSuccess: false,
                lessonStatementRules: [
                v => {
                    if (v)
                    {
                        this.lessonStatementSuccess = true;
                        return true;
                    } else {
                        this.lessonStatementSuccess = false;
                        return "Statement is required";
                    }
                },
                v =>
                    (v || "").length >= 2 ||
                    "Statement must be at least 2 characters long",
                v =>
                    (v || "").length <= 500||
                    "Statement must be less than 500 characters"
            ],*/

            lessonMaxWrongCountSuccess:false,
            lessonMaxWrongCountRules: [
                v =>
                    !(isNaN(v)) ||
                    "Max Wrong Count must be a number",
            ],
            lessonStatusSuccess: false,
            lessonStatusRules: [
              v=>(v===true||v===false)||"Status must be either true or false"
                 /* v => 
                    {
                    if (v) {
                        this.lessonStatusSuccess = true;
                        return true;
                    } else {
                        return "Lesson Status is required";
                    }
                },*/
                // v =>
                //     (v || "").length == 10 ||
                //     "Phone must be 10 characters long"    
            ],
        }
    },
      
      methods:{

        saveLesson() {
          //console.log("save lesson");
          this.disabled = true;
          if (this.lesson.lessonTitle.length<2 ||this.lesson.lessonTitle.length>30)
            {
              this.errorMessage = 'Title should be valid';
              setTimeout(() => (this.errorMessage = ""), 5000);
              this.disabled = false;
              return;
            }
          if (this.lesson.lessonDescription.length<2 || this.lesson.lessonDescription.length>255)
            {
              this.errorMessage = 'Description should be valid';
              setTimeout(() => (this.errorMessage = ""), 5000);
              this.disabled = false;
              return;
            }
            
          if (this.lesson.lessonIntroduction.length<2 || this.lesson.lessonIntroduction.length>255)
            {
              this.errorMessage = 'Introduction should be valid';
              setTimeout(() => (this.errorMessage = ""), 5000);
              this.disabled = false;
              return;
            }
          if (this.lesson.lessonInstruction.length<2 || this.lesson.lessonInstruction.length>255)
            {
              this.errorMessage = 'Instruction should be valid';
              setTimeout(() => (this.errorMessage = ""), 5000);
              this.disabled = false;
              return;
            }
          if (this.lesson.lessonStatementKeySequenceArray.length===0)
            {
              //console.error('Test')
              this.errorMessage = 'Please add a statement key sequence pair';
              setTimeout(() => (this.errorMessage = ""), 5000);
              this.disabled = false;
              return;
            }



            // if (isNaN(this.lesson.lessonMaxWrongCount)||this.lesson.lessonMaxWrongCount==='')
            //   {
            //     this.errorMessage = 'Please enter a numerical Max Wrong Count';
            //     setTimeout(() => (this.errorMessage = ""), 5000);
            //     this.disabled = false;
            //     return;
            //   }

            for(let i=0;i<this.lesson.lessonStatementKeySequenceArray.length;i++)
            {
              if(this.lesson.lessonStatementKeySequenceArray[i].lessonKeySequence.length===0||this.lesson.lessonStatementKeySequenceArray[i].lessonStatement==='')
              {
                this.errorMessage = 'Lesson Statement and key sequence cannot be empty';
                setTimeout(() => (this.errorMessage = ""), 5000);
                this.disabled = false;
                return;
              }
            }

            if(!this.lesson.lessonStatus)
              {
                this.lesson.lessonStatus=false;
              }

            if(!this.lesson.isPaid)
              {
                this.lesson.isPaid=false;
              }

            if (!(this.lesson.lessonStatus===true) && !(this.lesson.lessonStatus===false))
              {
                //console.log('question status inside', this.lesson.lessonStatus);
                this.errorMessage = 'Status should be valid';
                setTimeout(() => (this.errorMessage = ""), 5000);
                this.disabled = false;
                return;
              }

        console.log("lesson in save", this.lesson);
        Lesson.postLesson( this.lesson, this.auth.token)
          .then(res => {
            this.disabled = false;
            console.log('res', res);
            this.successMessage = 'Lesson saved successfully';
            setTimeout(() => (this.successMessage = ""), 5000);
            this.$refs.form.reset();
            this.lesson.lessonStatus=false;
          })
          .catch(err => {
            this.errorMessage = err.response.data;
            setTimeout(() => (this.errorMessage = ""), 5000);
            this.disabled = false;
            this.lesson.lessonStatus=false;
          });
        },

      addKey4(index)
        {
          //console.log("edited item 4", this.editedItem.lessonKeySequence, 'index', index);
          this.editedItem.lessonKeySequence.push(this.keySequenceMaster4[index]);
          //console.log(this.editedItem);
        },

      addKey5(index)
        {
          //console.log("edited item 5", this.editedItem.lessonKeySequence, 'index', index);
          this.editedItem.lessonKeySequence.push(this.keySequenceMaster5[index]);
          //console.log(this.editedItem);
        },

        addKey6(index)
        {
          //console.log("edited item 6", this.editedItem.lessonKeySequence, 'index', index);
          this.editedItem.lessonKeySequence.push(this.keySequenceMaster6[index]);
          //console.log(this.editedItem);
        },

      deleteKey(index)
        {
          this.editedItem.lessonKeySequence.splice(index, 1);
        },

      editLessonStatementKeySequence(item) {
        this.editedIndex = this.lesson.lessonStatementKeySequenceArray.indexOf(item)
        this.editedItem = Object.assign({}, item);
        //console.log('edit lesson stmt key seq', this.editedItem, this.editedIndex);
        this.dialog = true
      },

      deleteLessonStatementKeySequence (item) {
        this.editedIndex = this.lesson.lessonStatementKeySequenceArray.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteLessonStatementKeySequenceConfirm () {
        this.lesson.lessonStatementKeySequenceArray.splice(this.editedIndex, 1)
        this.closeDelete()
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        });
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        if (this.editedIndex > -1) 
          {
          Object.assign(this.lesson.lessonStatementKeySequenceArray[this.editedIndex], this.editedItem)
          } 
        else 
          {
            this.lesson.lessonStatementKeySequenceArray.push(this.editedItem)
          } 
        this.close();
        //console.log('lesson stmt key seq', this.lesson.lessonStatementKeySequenceArray, 'edited index', this.editedIndex);
        this.defaultItem={lessonKeySequence:[], lessonStatement:''};
        this.editedItem=this.defaultItem;
      },

      itemToString(item){
        return item.lessonKeySequence.toString()
      }, 
      clearForm(){
        this.$refs.form.resetValidation();
      },

      editTextTitle(e){
        this.textField=e.target;
        this.textField.blur();
        this.inputType="title"
        this.toBeEditedText=this.lesson.lessonTitle;
        this.editTextDialog=true;
        },

      editTextDescription(e){
        this.textField=e.target;
        this.textField.blur();
        this.inputType="desc"
        this.toBeEditedText=this.lesson.lessonDescription;
        this.editTextDialog=true;
      },

      editTextIntroduction(e){
        this.textField=e.target;
        this.textField.blur();
        this.inputType="introduction"
        this.toBeEditedText=this.lesson.lessonIntroduction;
        this.editTextDialog=true;
      },

      editTextInstruction(e){
        this.textField=e.target;
        this.textField.blur();
        this.inputType="instruction"
        this.toBeEditedText=this.lesson.lessonInstruction;
        this.editTextDialog=true;
      },
      editTextStatement(e){
        this.textField=e.target;
        this.textField.blur();
        this.inputType="statement"
        this.toBeEditedText=this.editedItem.lessonStatement;
        this.editTextDialogStatement=true;
      },

      changeEditedText(editedText) {
        if(editedText===null)
          {
            if(this.inputType==="statement")
              this.editTextDialogStatement=false;
            else  
              this.editTextDialog=false;
          }
          else
            {
              //console.log("Selected: "+ this.inputType );
              this.toBeEditedText=editedText;
              if(this.inputType == 'title') 
                {
                  this.lesson.lessonTitle = editedText;
                  this.editTextDialog = false;
                }
              else  if(this.inputType == 'desc') {
                  this.lesson.lessonDescription = editedText;
                  this.editTextDialog = false; 
                }
              else  if(this.inputType == 'introduction') {
                  this.lesson.lessonIntroduction = editedText;
                  this.editTextDialog = false; 
                }
              else  if(this.inputType == 'instruction') {
                  this.lesson.lessonInstruction = editedText;
                  this.editTextDialog = false; 
                }

              else  if(this.inputType == 'statement') {
                  this.editedItem.lessonStatement= editedText;
                  this.editTextDialogStatement = false; 
                }
            }            
      }
    },

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },
      auth() {
        return this.$store.state.auth;
      },
    },

    watch: {
      dialog (val) {
        val || this.close();
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
      
    },
        mounted()
        {

        }
    }

</script>
<style scoped>
.custom_form {
    margin: 10px 0 0;
    border-top: 3px solid #1b73ba;
}
.custom_form >>> .v-card {
    padding-top: 20px;
}
</style>